<script>
import moment from 'moment';

module.exports = {
  template: '#topnav-template',
  data: function() {
    return {
      showMobileNav: false
    };
  },
  watch: {
    $route: function() {
      this.showMobileNav = false;
    }
  },
  methods: {
    toggleMobileNav: function() {
      if (this.showMobileNav) this.showMobileNav = false;
      else this.showMobileNav = true;
    }
  },
  computed: {
    user: function() {
      let user = this.$store.state.user;

      user.lastnameFirstLetter = user.lastname ? user.lastname.charAt(0).toUpperCase() : user.lastname;

      return user;
    },
    messages: function() {
      const messages = this.$store.state.messages ? this.$store.state.messages : [];

      const latestMessages = messages.reduce(function(result, message) {
        if (!message.isRead) result.push(message);

        return result;
      }, []).length;

      return latestMessages > 0 ? latestMessages : false;
    }
  }
};
</script>